import React from 'react'

export const DataProviderContext = React.createContext<{
    data?: any[] | any
    loading?: boolean
    refresh?: () => Promise<any>
}>({})
